import MobileApplication from './MobileApplication'
import MobileApplicationDependencies from './MobileApplicationDependencies'

export default new MobileApplication(MobileApplicationDependencies)
